
/* styles */
require("!!../../../../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-d18837f4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CustomerTimelineSummaryWidget.vue")

var Component = require("!../../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CustomerTimelineSummaryWidget.vue"),
  /* template */
  require("!!../../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-d18837f4\"}!../../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CustomerTimelineSummaryWidget.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./libs/@db2b/keystone/components/Widgets/Customers/Summary/Timeline/CustomerTimelineSummaryWidget.vue
// module id = 637
// module chunks = 1